import React, { ReactNode } from 'react';
import Button, {
    ButtonTypes,
} from 'components/shared/generic/button/presentational/Button';
import useTranslate from 'lib/languages/useTranslate';

interface ModalOuterProps {
    className?: string;
    children?: ReactNode;
    customButtons?: boolean;
    isPosting?: boolean;
    handleClose?: () => void;
    handleSubmit?: (e: React.MouseEvent) => void;
    submitButtonText?: string;
    cancelButtonText?: string;
}

const ModalOuter = ({
    className,
    children,
    customButtons,
    isPosting,
    handleClose,
    handleSubmit,
    submitButtonText,
    cancelButtonText,
}: ModalOuterProps) => {
    const translate = useTranslate('generic');

    return (
        <div className="modal-container size-lg-12">
            <div className={`modal-block ${className || ''}`}>
                {children}

                <div
                    className={`button-container ${
                        customButtons ? 'no-display' : ''
                    }`}
                >
                    <Button className="cancel" onClick={handleClose}>
                        {cancelButtonText ?? translate('cancel')}
                    </Button>
                    <Button
                        type={ButtonTypes.SUBMIT}
                        onClick={handleSubmit}
                        isPosting={isPosting}
                        tracking
                        trackingLabel="MODAL_OPEN"
                    >
                        {submitButtonText ?? translate('confirm')}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ModalOuter;
